<template>
  <div
      class="app-container"
      :class="{
        'app-container-active': navStatus,
        'app-dark-theme': !themeStatus
      }"
  >
    <div class="app-wrapper">
      <div class="root">
        <div id="nav">
          <navbar />
          <nav-burger />
        </div>
        <div class="router-view">
          <router-view v-slot="{ Component }">
            <transition name="fade" mode="out-in">
              <component :is="Component" v-if="show"/>
            </transition>
          </router-view>
        </div>
      </div>
      <Footer />
      <div
          class="sidebar-mask"
          @click="changeNavStatus"
          v-if="navStatus"
      />
    </div>
  </div>
  <sidebar />
</template>

<script>
import Footer from "./components/Footer";
import NavBurger from "./components/NavBurger";
import Navbar from "./components/Navbar";
import Sidebar from "./components/Sidebar";
import {mapMutations, mapState} from "vuex";

export default {
  name: "App",
  data() {
    return {
      a: [1, 2, 3]
    }
  },
  computed: {
    ...mapState([
      "navStatus",
      "themeStatus",
      "show"
    ]),
  },
  mounted() {
    const resizeObserver = new ResizeObserver(this.checkNavStatus);
    resizeObserver.observe(document.body)
    console.log(this)
  },
  methods: {
    ...mapMutations([
      "changeNavStatus"
    ]),
    checkNavStatus() {
      if (window.innerWidth > 768 && this.navStatus) {
        this.changeNavStatus()
      }
    }
  },
  components: {
    NavBurger,
    Sidebar,
    Navbar,
    Footer
  }
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  width: 100%;
  height: 100%;
}

.app-wrapper {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: auto;
}

.root {
  flex-grow: 1;
}

.app-container {
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background-color: white;
  position: fixed;
  transition: 0.2s;
  z-index: 100;
  flex-grow: 1;
}

.app-container-active {
  left: -40%
}

.sidebar-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 60%;
  height: 100%;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

#nav {
  padding: 20px;
}

a {
  font-weight: bold;
  color: #2c3e50;
  text-decoration: none;
  transition: 1s;

  &.router-link-exact-active {
    color: #26ade4;

  }
}

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
body {
  transition: background 0.2s linear;
}

html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
}

.router-view {
  width: 90%;
  max-width: 800px;
  margin: 0 auto;
}

.app-dark-theme {
  background-color: #4a4040;
  transition: 0.5s ease all;
  .home, .career {
    color: white;
  }
  .navbar-text {
    color: white;
  }

  .burger-line {
    background-color: white;
  }
  a {
    color: #ccc;
    &.router-link-exact-active {
      color: white;

    }
  }
  .home-text, .task {
    color: #ccc;
  }
  .footer-body {
    color: white;
  }
  .language-switcher {
    .switch {
      color: #ccc;
      .language-active {
        color: white;
      }
    }
  }
  .step-level, .step-time-line-element, .technology {
    background-color: white !important;
    color: #2c3e50 !important;
  }
  .step-time-start, .step-description, .step-time-end {
    color: #cccccc;
  }
  .social-media-item a {
    color: white;
  }

  .title {
    color: white;
  }
}

@media only screen and (max-width : 500px) {
  .app-container-active {
    left: -50%
  }
  .sidebar-mask {
    width: 50%;
  }
}
</style>
